<div class="section">
    <div class="nova__label">Coverage</div>
    <div data-qa-id="locums-schedule-coverage-value">{{job.coverageTypeName | nullDash}}</div>

    <div data-qa-id="locums-schedule-start-date-label" class="nova__label">Start Date</div>
    <div data-qa-id="locums-schedule-start-date-div">
        <div class="sub-section">
            <div data-qa-id="locums-schedule-start-date-value">{{job.startDate | date : "M/d/yyyy" : 'UTC'}}</div>
        </div>

            <div data-qa-id="locums-schedule-start-date-external-value">
                <span class="external-info" *ngIf="displayConfigData?.hideStartDate">
                    <span class="material-icons">info</span>hidden externally
                </span>
                <span class="external-info" *ngIf="!displayConfigData?.hideStartDate && (displayConfigData?.startDate?.toString().length !== 0 && displayConfigData?.startDate !== null)">
                    <span class="material-icons">info</span>Displays as "{{displayConfigData?.startDate | date : "M/d/yyyy" : 'UTC'}}"
                </span>
            </div>

    </div>

    <div data-qa-id="locums-schedule-shift-desc-label" class="nova__label">Shift Description</div>
    <div data-qa-id="locums-schedule-shift-desc-value">{{job.shiftTypeDescription | nullDash}}</div>

    <div data-qa-id="locums-schedule-shift-label" class="nova__label">Shift Schedule</div>
    <div>
        <div class="sub-section">
            <div data-qa-id="locums-schedule-shift-type-value">{{ job.isAlternating ? 'Alternating' : 'Standard' }}</div>
        </div>
        <div class="sub-section">
            <div data-qa-id="locums-schedule-shift-type-desc-value">{{job.shiftDescription | nullDash}}</div>
        </div>
        <div>
            <div data-qa-id="locums-schedule-shift-type-desc-external-value">
                <span class="external-info" *ngIf="!displayConfigData?.hideShiftNote && (displayConfigData?.shiftNote !== '' && displayConfigData?.shiftNote !== null)">
                    <span class="material-icons">info</span>Displays with note "{{displayConfigData?.shiftNote}}"
                </span>
            </div>
        </div>
    </div>

    <div data-qa-id="locums-schedule-details-label" class="nova__label">Schedule Details</div>
    <div [ngClass]="{'schedule-details-text' : hasContent}" data-qa-id="locums-schedule-details-value">
        <div [innerHTML]="!hasContent ? '-' : job.scheduleDetailsText"></div>
    </div>
</div>
